module.exports = __webpack_public_path__ + "static/media/Stageplan1.6ac030b5.pdf";